import type { ColorCollectionDto } from '@builder4/shared/dto/styles/ColorCollectionDto';
import type { Palette } from '@/components/inspector-fields/ColorPicker/ColorPicker';
import type { Color, Gradient } from '@builder4/shared/types/layout';
import { rgbaToHexa, checkIsGradient } from '@builder4/shared/utils/styleHelpers';

/**
 * Creates a color picker palette from global styles color collection.
 * Converts the 6 global colors (color1-color6) into a palette format
 * that can be used with the ColorPicker component.
 *
 * @param colors - ColorCollectionDto containing color1-color6
 * @returns Palette with name "Styles", marked as readonly, containing all 6 colors
 */
export const createPaletteFromGlobalColors = (colors: ColorCollectionDto): Palette => {
  const colorKeys = ['color1', 'color2', 'color3', 'color4', 'color5', 'color6'] as const;

  const paletteColors = colorKeys.map((key, index) => {
    const colorDto = colors[key];
    const colorNumber = index + 1;
    const colorValue = colorDto.value as Color;

    const isGradient = checkIsGradient(colorValue);

    if (isGradient) {
      return {
        name: colorDto.name,
        gradient: colorValue as Gradient,
        reference: `$ref:#/colors/color${colorNumber}`,
      };
    }

    return {
      name: colorDto.name,
      hex: rgbaToHexa(colorValue),
      reference: `$ref:#/colors/color${colorNumber}`,
    };
  });

  return {
    name: 'Page Style',
    colors: paletteColors,
    readOnly: true,
  };
};
